import { render } from "./FacultyCourseLoadDialog.vue?vue&type=template&id=89ab9b12"
import script from "./FacultyCourseLoadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyCourseLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__